import { DesktopSignupPage } from '@/app/pages/DesktopSignupPage';

export function ResponsiveSignupPage() {
  return <DesktopSignupPage />;
}
